import React from 'react';
import 'twin.macro';

const Callout: React.FC = ({ children }) => (
  <div tw="flex space-x-4 max-w-3xl my-6">
    <div tw="bg-blue rounded-xl w-4 flex-shrink-0" />
    <div tw="text-blue font-semibold">{children}</div>
  </div>
);

export default Callout;
